/**
 * DigitalPeriodBanner — Faixa informativa de periodo da area Digital.
 *
 * Exibida nas abas que usam o filtro global de periodo (Visao geral, Instagram,
 * Meta Ads). A aba "Analise de campanhas" nao exibe — ela tem seletor proprio.
 *
 * O botao "Clique aqui" rola ao topo da pagina e foca o seletor de periodo
 * da topbar (#topbar-period-select), sem duplicar o controle.
 *
 * A11y: role="note", button com aria-label descritivo, focus-visible.
 * i18n: todos os textos via t() — zero string hardcoded.
 * Contraste: --md-on-secondary-container (#00344F) sobre
 *            --md-secondary-container (#D4E7FF) = 8.0:1 — AAA.
 *
 * F3 — 2026-06-09
 */

import { t } from '../lib/i18n';
import { useFilterContext } from '../lib/filter-context';

// ---------------------------------------------------------------------------
// Helper: label legivel do periodo aplicado
// ---------------------------------------------------------------------------

export function resolvePeriodLabel(
  periodMode: string,
  appliedYear: number,
  appliedMonth: number,
): string {
  if (periodMode === '7d') return t('digital.periodLabel7d');
  if (periodMode === '30d') return t('digital.periodLabel30d');
  if (periodMode === '90d') return t('digital.periodLabel90d');
  if (periodMode === '365d') return t('digital.periodLabel365d');
  if (periodMode === 'month') {
    // Ex.: "abril de 2026"
    const monthName = t(
      `fourPs.monthFilter.months.m${appliedMonth}` as 'fourPs.monthFilter.months.m1',
    ).toLowerCase();
    return `${monthName} de ${appliedYear}`;
  }
  return periodMode;
}

// ---------------------------------------------------------------------------
// Componente
// ---------------------------------------------------------------------------

export function DigitalPeriodBanner(): JSX.Element {
  const { applied } = useFilterContext();
  const { periodMode, appliedYear, appliedMonth } = applied;

  const label = resolvePeriodLabel(periodMode, appliedYear, appliedMonth);

  function handleClick(): void {
    // Rola ao topo sem deslocar o foco antes de ele chegar ao seletor
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Aguarda o scroll iniciar antes de focar o seletor de periodo da topbar
    setTimeout(() => {
      const el = document.getElementById('topbar-period-select');
      if (el !== null) {
        (el as HTMLElement).focus();
      }
    }, 120);
  }

  return (
    <div
      className="digital-period-banner"
      role="note"
      aria-label={`${t('digital.periodBannerPrefix')} ${label}`}
    >
      <span className="digital-period-banner__icon material-symbols-rounded" aria-hidden="true">
        calendar_month
      </span>
      <span className="digital-period-banner__text">
        {t('digital.periodBannerPrefix')} <strong>{label}</strong>
        {' — '}
        <button
          type="button"
          className="digital-period-banner__cta"
          onClick={handleClick}
          aria-label={t('digital.periodBannerCtaAriaLabel')}
        >
          {t('digital.periodBannerCta')}
        </button>
      </span>
    </div>
  );
}
